<template>
    <div v-if="ready">
        <onboarding-layout v-if="showOnboarding && !showNotification">
            <template #header>
                <template v-if="!isAllCompleted">
                    <span @click="pauseOnboarding = true" v-if="!pauseOnboarding"><h1 style="cursor:pointer; right:0"> X </h1></span>
                    <h3 style="text-align:center;" >
                        {{ $t('welcomeToOnboarding') }}
                    </h3>
                </template>

                <h3 style="text-align:center;" v-else>
                    {{ $t('congratulations') }}
                </h3>
            </template>

            <template #default>
                <div v-if="pauseOnboarding" style="text-align:center">
                    <h5>{{ $t('pauseOnboardingWarning') }} </h5>
                    <b-row class="mt-5">
                        <b-col><b-button variant="warning" @click="pause" block>{{ $t('yes') }}</b-button></b-col>
                        <b-col><b-button variant="success" @click="pauseOnboarding = false" block>{{ $t('no') }}</b-button></b-col>
                    </b-row>
                </div>
                
                <div v-else>
                    <b-row v-if="currentOnboarding">
                        <b-col cols="12" v-if="currentOnboarding.type == 'platform' && currentOnboarding.id == 'locale'">
                            <b-form-group
                                :label="$t(`choosePreferedLanguage`)"
                            >
                                <b-select :options="localeOptions" v-model="initialLocale"/>
                                <b-button @click="saveLocale" variant="success" class="mt-2" block :disabled="stepInProcess"> {{ $t('save') }} </b-button>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" v-if="currentOnboarding.type == 'integration'">
                            <RenderEvent event="onboarding" @onboardingSuccess="onboardingSuccess" tag="div" :only="currentOnboarding.id" :key="currentOnboarding.id"/>
                        </b-col>

                        <b-col cols="12" v-if="currentOnboarding.type == 'app'">
                            <AppOnboarding :id="currentOnboarding.id" @onboardingSuccess="onboardingSuccess" />
                        </b-col>

                        <b-col cols="12" v-if="currentOnboarding.type == 'public-app'">
                            <PublicAppOnboarding :id="currentOnboarding.id" @onboardingSuccess="onboardingSuccess" />
                        </b-col>
                    </b-row>

                    <b-row v-if="isAllCompleted">
                        <b-col cols="12">
                            <h5 style="text-align:center">{{ $t('onboardingCongrats') }}</h5>
                        </b-col>
                        <b-col cols="12" style="text-align:center">
                            <b-button variant="success" @click="close"> {{ $t('continue')  }}</b-button>
                        </b-col>
                    </b-row>
                </div>
            </template>
        </onboarding-layout>

        <OnboardingNotification :shouldContinue="showNotification"/>
    </div>
</template>

<script>
import OnboardingLayout from './OnboardingLayout'
import OnboardingNotification from './OnboardingNotification'
import RenderEvent from '@/components/integrations/RenderEvent'
import vSelect from 'vue-select'
import AppOnboarding from '@/views/apps/Onboarding'
import PublicAppOnboarding from '@/views/publicapps/Onboarding'

export default {
    components: {
        OnboardingLayout,
        RenderEvent,
        vSelect,
        OnboardingNotification,
        AppOnboarding,
        PublicAppOnboarding
    },

    data: () => {
        return {
            ready: false,
            success: false,
            pauseOnboarding: false,
            locale: 'en_US',
            localeOptions: [
                {
                    value: 'en_US',
                    text: 'English (US)'
                },
                {
                    value: 'sr',
                    text: 'Serbian'
                },
            ],

            stepInProcess: false,

            initiatedOnboarding: []
        }
    },

    methods: {
        onboardingSuccess(type, id) {
            console.log("onboardingSuccess", type, id)
            this.initiatedOnboarding = this.initiatedOnboarding.map(i => {
                if (i.type == type && i.id == id) {
                    i.completed = true
                }

                return i
            })
        },

        async saveLocale() {
            try {
                this.stepInProcess = true;
                await this.$store.dispatch("updateUserConfig", { path: "locale", data: { locale: this.locale } })

                this.$store.commit('SET_LOCALE', this.locale)
                this.$i18n.locale = this.locale

                this.onboardingSuccess("platform", "locale")
            } catch {
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger'
                })
            } finally {
                this.stepInProcess = false
            }
        },

        async pause() {
            this.$store.dispatch('pauseOnboarding')
            this.pauseOnboarding = false
        },

        close() {
            this.initiatedOnboarding = []
        }
    },

    computed: {
        isAllCompleted() {
            return this.initiatedOnboarding.filter(i => !i.completed).length < 1
        },

        currentOnboarding() {
            // is there any platform onboarding?
            const platformOnboarding = this.initiatedOnboarding.find(i => i.type == "platform" && !i.completed)
            if (platformOnboarding) {
                return platformOnboarding
            }

            const n = this.initiatedOnboarding.find(i => !i.completed)

            return n
        },

        showNotification() {
            return this.$store.getters.getPausedOnboardings.length > 0
        },

        showOnboarding() {
            return this.initiatedOnboarding.length > 0
        },

        initialLocale: {
            get() {
                return 'en_US'
            },

            set(val) {
                this.locale = val
                this.$root.$i18n.locale = val
            }
        }
    },

    async mounted() {
        try {
            await Promise.all([
                this.$store.dispatch("fetchApps"),
                this.$store.dispatch("fetchIntegrations"),
                this.$store.dispatch("fetchUserConfigs"),
                this.$store.dispatch("fetchPublicAppsOnboarding")
            ])

            //let data = this.$store.getters.userConfig('locale')
            //this.$store.commit('SET_LOCALE', _.get(data[0], "data.locale", 'en_US'))

            let lang = this.$store.getters.userConfig("locale")
            console.log("Lang", lang)
            if (lang.length < 1) {
                this.initiatedOnboarding.push({
                    priority: 1,
                    type: 'platform',
                    id: 'locale',
                    completed: false
                })
            }

            const onboardingIntegrations = this.$store.getters.getOnboardingRequiredIntegrations || []
            onboardingIntegrations.forEach(o => {
                if (o.onboarded) return

                this.initiatedOnboarding.push({
                    priority: 2,
                    type: 'integration',
                    id: o.id,
                    completed: o.onboarded
                })
            })

            const onboardingPlatformApps = this.$store.getters.getOnboardingRequiredPlatformApps || []
            onboardingPlatformApps.forEach(o => {
                if (o.onboarding.finished) return

                this.initiatedOnboarding.push({
                    priority: 3,
                    type: 'app',
                    id: o.uuid,
                    completed: o.onboarding.finished
                })
            })

            const onboardingPublicApps = this.$store.getters.getOnboardingRequiredPublicApps || []
            onboardingPublicApps.forEach(o => {
                if (o.onboarding.finished) return

                this.initiatedOnboarding.push({
                    priority: 4,
                    type: 'public-app',
                    id: o.uuid,
                    completed: o.onboarding.finished
                })
            })

            this.initiatedOnboarding.sort((a, b) => a - b)

            this.ready = true
        } catch(err) {
            console.error(err)
            this.$bvToast.toast(this.$t('unexpectedError'), {
                variant: 'danger'
            })
        }
    }
}
</script>